import React from 'react';
import { Link } from 'react-router-dom';

const s = {
  hero: { background: 'linear-gradient(135deg, #1c1814 0%, #2d2420 100%)', color: '#faf7f2', padding: '6rem 2rem', textAlign: 'center' },
  heroInner: { maxWidth: 760, margin: '0 auto' },
  badge: { display: 'inline-block', background: 'rgba(192,57,43,0.2)', color: '#e8866f', border: '1px solid rgba(192,57,43,0.3)', borderRadius: 100, padding: '4px 14px', fontSize: '0.78rem', fontWeight: 600, marginBottom: '1.5rem', letterSpacing: '0.05em' },
  h1: { fontFamily: 'Fraunces, serif', fontSize: 'clamp(2.5rem,6vw,4rem)', fontWeight: 600, lineHeight: 1.15, marginBottom: '1.25rem', color: '#faf7f2' },
  span: { color: '#e8b86d' },
  sub: { fontSize: '1.1rem', color: 'rgba(250,247,242,0.6)', lineHeight: 1.8, marginBottom: '2.5rem', maxWidth: 580, margin: '0 auto 2.5rem' },
  ctaRow: { display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' },
  btnPrimary: { background: '#c0392b', color: '#fff', padding: '0.9rem 2rem', borderRadius: 10, textDecoration: 'none', fontWeight: 600, fontSize: '0.95rem' },
  btnSec: { background: 'rgba(255,255,255,0.08)', color: '#faf7f2', padding: '0.9rem 2rem', borderRadius: 10, textDecoration: 'none', fontWeight: 600, fontSize: '0.95rem', border: '1px solid rgba(255,255,255,0.15)' },
  stats: { background: '#fff', padding: '3rem 2rem', borderBottom: '1px solid #e2dbd0' },
  statsInner: { maxWidth: 900, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '2rem', textAlign: 'center' },
  statN: { fontFamily: 'Fraunces, serif', fontSize: '2.5rem', fontWeight: 600, color: '#c0392b' },
  statL: { fontSize: '0.875rem', color: '#7a6f65', marginTop: '0.3rem' },
  section: { maxWidth: 1100, margin: '0 auto', padding: '5rem 2rem' },
  sectionTitle: { fontFamily: 'Fraunces, serif', fontSize: '2rem', fontWeight: 600, color: '#1c1814', textAlign: 'center', marginBottom: '3rem' },
  howGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))', gap: '2rem' },
  howCard: { background: '#fff', border: '1px solid #e2dbd0', borderRadius: 16, padding: '2rem', textAlign: 'center' },
  howIcon: { fontSize: '2rem', marginBottom: '1rem' },
  howTitle: { fontWeight: 600, color: '#1c1814', marginBottom: '0.5rem' },
  howDesc: { fontSize: '0.875rem', color: '#7a6f65', lineHeight: 1.7 },
  founderSection: { background: '#1c1814', color: '#faf7f2', padding: '5rem 2rem' },
  founderInner: { maxWidth: 700, margin: '0 auto', textAlign: 'center' },
  founderTitle: { fontFamily: 'Fraunces, serif', fontSize: '1.8rem', marginBottom: '1rem', color: '#e8b86d' },
  founderText: { color: 'rgba(250,247,242,0.6)', lineHeight: 1.8, marginBottom: '1.5rem' },
  founderName: { fontWeight: 600, color: '#faf7f2' },
};

export default function Home() {
  return (
    <div>
      <div style={s.hero}>
        <div style={s.heroInner}>
          <div style={s.badge}>936 tech workers laid off every day</div>
          <h1 style={s.h1}>Help laid-off people <span style={s.span}>rise again</span></h1>
          <p style={s.sub}>LayoffFund is a verified crowdfunding platform built exclusively for people who've lost their jobs. Every campaign is real. Every donor makes a difference.</p>
          <div style={s.ctaRow}>
            <Link to="/campaigns" style={s.btnPrimary}>Browse campaigns →</Link>
            <Link to="/create-campaign" style={s.btnSec}>Start a campaign</Link>
          </div>
        </div>
      </div>

      <div style={s.stats}>
        <div style={s.statsInner}>
          {[['₹0', 'Total raised so far'], ['0', 'Campaigns funded'], ['0', 'Donors worldwide']].map(([n, l]) => (
            <div key={l}><div style={s.statN}>{n}</div><div style={s.statL}>{l}</div></div>
          ))}
        </div>
      </div>

      <div style={s.section} id="how">
        <h2 style={s.sectionTitle}>How it works</h2>
        <div style={s.howGrid}>
          {[
            ['📝', 'Create your campaign', 'Tell your story — who you are, where you worked, and what you need support for.'],
            ['✅', 'Get verified', 'Upload your layoff letter. Our team reviews and approves within 24 hours.'],
            ['🌍', 'Receive donations', 'Donors from around the world can support you via UPI, Stripe, or card.'],
            ['💰', 'Get funded', 'Once your goal is reached, funds are transferred directly to you.'],
          ].map(([icon, title, desc]) => (
            <div key={title} style={s.howCard}>
              <div style={s.howIcon}>{icon}</div>
              <div style={s.howTitle}>{title}</div>
              <div style={s.howDesc}>{desc}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={s.founderSection} id="founder">
        <div style={s.founderInner}>
          <div style={s.founderTitle}>Built by someone who gets it</div>
          <p style={s.founderText}>
            LayoffFund was founded after witnessing firsthand how devastating a layoff can be — the financial stress, the uncertainty, the feeling of being alone. 
            We built this platform to make sure no one has to face that alone.
          </p>
          <div style={s.founderName}>Santosh Pujeri — Founder & CEO, LayoffFund</div>
          <div style={{ marginTop: '1rem' }}>
            <a href="https://linkedin.com/in/santosh-pujeri" target="_blank" rel="noreferrer"
              style={{ color: '#e8b86d', fontSize: '0.875rem', fontWeight: 600 }}>
              Connect on LinkedIn →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
